/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { forwardRef } from "react";
import Button from "@mui/material/Button";

const ButtonLargeOutlinedGrey = forwardRef((props, ref) => {

    const commonProps = {
        className: `outlined grey ${props.className ? props.className : ""}`,
        variant: "outlined",
        color: "secondary",
        size: "large",
    };

    //  Combine ClassName from "default" and "props"
    const asArray = Object.entries(props);
    const filtered = asArray.filter(([key]) => key !== "className");
    const propsFilter = Object.fromEntries(filtered);

    const allProps = {
        ...commonProps,
        ...propsFilter,
    };

    return (
        <Button ref={ref} {...allProps} style={{ color: "#2D2D2D", borderColor: "#2D2D2D" }}>
            {props?.label}
        </Button>
    );
});

ButtonLargeOutlinedGrey.displayName = "ButtonLargeOutlinedGrey";
export { ButtonLargeOutlinedGrey };
